import { createActionHelpers } from 'vuex-loading';
import m from 'moment';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    safeDropLimit: 300,
    outletSafeDrop: {
        safe_drop_limit: 200,
        customTimes: [],
    },
};

const getters = {
    safeDropLimit: state => state.safeDropLimit,

    outletSafeDrop() {
        let outletSafeDrop = state.outletSafeDrop;

        outletSafeDrop.customTimes.map(time => {
            time.start_time = m(time.start_time, [
                m.ISO_8601,
                'HH:mm:ss',
            ]).format();

            time.end_time = m(time.end_time, [m.ISO_8601, 'HH:mm:ss']).format();

            return time;
        });

        return outletSafeDrop;
    },
};

const mutations = {
    setSafeDropLimit(data) {
        state.safeDropLimit = data;
    },

    setOutletSafeDrop(state, data) {
        state.outletSafeDrop = data;
    },
};

const actions = {
    async saveSafeDropLimit({ commit, dispatch }, params) {
        const url = Laroute.route('franchise.attendant.tagging.save');
        startLoading(dispatch, 'save-safe-drop-limit');

        try {
            const { data } = await axios.post(url, params);
            endLoading(dispatch, 'save-safe-drop-limit');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-safe-drop-limit');
            throw e;
        }
    },

    async saveAttendantCard({ commit, dispatch }, data) {
        const url = Laroute.route('franchise.attendant.tagging.card.save');
        startLoading(dispatch, 'save-attendant-card');

        let params = {
            id: data.id,
            outlet_id: data.outlet_id,
            pan_number: data.pan_number,
            description: data.description,
        };

        try {
            const { data } = await axios.post(url, params);
            endLoading(dispatch, 'save-attendant-card');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-attendant-card');
            throw e;
        }
    },

    async updateAttendantCard({ commit, dispatch }, card) {
        const url = Laroute.route('franchise.attendant.tagging.card.save');
        startLoading(dispatch, 'save-attendant-card');

        try {
            const { data } = await axios.post(url, card);
            endLoading(dispatch, 'save-attendant-card');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-attendant-card');
            throw e;
        }
    },

    async getOutletSafeDrop({ commit, dispatch }, outletId) {
        const url = Laroute.route('franchise.attendant.tagging.show', {
            outletId,
        });

        startLoading(dispatch, 'get-outlet-safe-drop');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'get-outlet-safe-drop');
            commit('setOutletSafeDrop', data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-outlet-safe-drop');
            throw e;
        }
    },

    async saveOutletSafeDrop({ commit, dispatch, state }, outletId) {
        const url = Laroute.route(
            'franchise.attendant.tagging.save.outlet.safe.drop',
        );

        startLoading(dispatch, 'save-outlet-safe-drop');

        state.outletSafeDrop.outlet_id = outletId;

        try {
            const { data } = await axios.post(url, state.outletSafeDrop);
            commit('setOutletSafeDrop', data);
            endLoading(dispatch, 'save-outlet-safe-drop');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-outlet-safe-drop');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
